export default __webpack_public_path__ + "static/media/Index.tsx.9fc534c9.txt";